import { STYLE_COMMANDS } from '../../../../../common/richText/richTextConstants';

export default (blockType) =>
    blockType === STYLE_COMMANDS.CHECKLIST ||
    blockType === STYLE_COMMANDS.ORDERED_LIST ||
    blockType === STYLE_COMMANDS.LIST;
